import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import {
  Box,
  Card,
  CardHeader,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  useMediaQuery,
  Typography,
} from '@mui/material';
import {
  AssignmentIndOutlined as AssignmentIndIcon,
  CakeOutlined as CackeIcon,
  JoinLeftOutlined as JoinLeftIcon,
  EmailOutlined as EmailIcon,
  PhoneAndroidOutlined as PhoneAndroidIcon,
  PlaceOutlined as PlaceIcon,
} from '@mui/icons-material';
import { DefaultContainedButton } from '../../utils/Buttons';

/**
 *
 * @param {string} title
 * @returns User Dashboard profile card UI
 */
export default function AppProfile({ title }) {
  const navigate = useNavigate();
  const is600Screen = useMediaQuery('(min-width: 600px)');
  const [userInfo, setUserInfo] = useState([]);
  const [birthDate, setBirthDate] = useState();
  const [masterEntity, setMasterEntity] = useState({});

  // Get user data from local web storage
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('userData'));

    if (data) {
      const birthDate = dayjs(data.birth_date).format('DD/MM/YYYY');
      setBirthDate(birthDate);
      setUserInfo(data);
      const master = data.entities.find((entity) => entity.id === data.entity_id);
      setMasterEntity(master);
    }
  }, []);

  const handleGoToProfile = () => {
    navigate('/user/profile', { state: { selectedTab: 1 } });
  };

  return (
    <Card sx={{ backgroundColor: '#d5f4e7', height: is600Screen ? '460px' : 'auto' }}>
      <CardHeader title={title} />

      <Box sx={{ mx: 3 }} dir="ltr">
        <Grid
          container
          sx={{
            margin: '30px 0',
            justifyContent: 'start !important',
            flexWrap: is600Screen ? 'nowrap !important' : 'wrap',
          }}
        >
          {/* User Profile Avatar */}
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'start',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: { xs: '12px', sm: '0' },
            }}
          >
            <Box>
              <Typography variant="h3" gutterBottom>
                Bentornat* {userInfo.name_alias === null ? `${userInfo.name}` : userInfo.name_alias}!
              </Typography>
              <Typography color="tertiary">
                {userInfo.card_holder ? 'Utente tesserato' : 'Utente non tesserato'}
              </Typography>
            </Box>
            {!!!userInfo.has_current_card && (
              <Box>
                <DefaultContainedButton onClick={handleGoToProfile}>Vai al Tesseramento</DefaultContainedButton>
              </Box>
            )}
          </Grid>
        </Grid>

        <Divider />

        {/* Checkboxes */}
        <Grid item>
          <List>
            <ListItem>
              <ListItemIcon>
                <AssignmentIndIcon color="secondary" fontSize="medium" />
              </ListItemIcon>
              <ListItemText primary={userInfo.fiscal_code} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CackeIcon color="secondary" fontSize="medium" />
              </ListItemIcon>
              <ListItemText primary={birthDate} />
            </ListItem>
            {/* <ListItem>
              <ListItemIcon>
                <JoinLeftIcon color="secondary" fontSize="medium" />
              </ListItemIcon>
              <ListItemText primary={`Iscritto dal ${dayjs(userInfo.created_at).format('DD/MM/YYYY')}`} />
            </ListItem> */}
            <ListItem>
              <ListItemIcon>
                <EmailIcon color="secondary" fontSize="medium" />
              </ListItemIcon>
              <ListItemText sx={{ wordBreak: 'break-all' }} primary={userInfo.email} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <PhoneAndroidIcon color="secondary" fontSize="medium" />
              </ListItemIcon>
              <ListItemText primary={`${userInfo.call_code} ${userInfo.phone}`} />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <PlaceIcon color="secondary" fontSize="medium" />
              </ListItemIcon>
              {/* <ListItemText primary={`Circolo: ${masterEntity.name}`} /> */}
            </ListItem>
          </List>
        </Grid>
      </Box>
    </Card>
  );
}
